import React, { useState } from "react";
import { signInWithEmailAndPassword, createUserWithEmailAndPassword } from "firebase/auth";
import { auth } from "../firebase";
import plumbuiltLogo from "../images/plumbuilt-logo.png";
import "./SignIn.css";

const SignIn: React.FC<{ onAuth: () => void }> = ({ onAuth }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isSignUp, setIsSignUp] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    try {
      if (isSignUp) {
        await createUserWithEmailAndPassword(auth, email, password);
      } else {
        await signInWithEmailAndPassword(auth, email, password);
      }
      onAuth();
    } catch (err: any) {
      setError(err.message);
    }
  };

  return (
    <div className="signin-container">
      <div className="signin-card">
        <img src={plumbuiltLogo} alt="Plumbuilt Logo" className="signin-logo" />
        <h2>{isSignUp ? "Sign Up" : "Sign In"}</h2>
        <form onSubmit={handleSubmit}>
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
            autoFocus
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            required
          />
          <button type="submit">{isSignUp ? "Create Account" : "Sign In"}</button>
        </form>
        <div className="signin-toggle">
          {isSignUp ? (
            <span>
              Already have an account?{" "}
              <button onClick={() => setIsSignUp(false)}>Sign In</button>
            </span>
          ) : (
            <span>
              New here?{" "}
              <button onClick={() => setIsSignUp(true)}>Sign Up</button>
            </span>
          )}
        </div>
        {error && <div className="signin-error">{error}</div>}
      </div>
    </div>
  );
};

export default SignIn; 